import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { SelectedAuctionFacade } from 'libs/gb-dashboard/auctions/data-access-selected-auction/src/lib/+state/selected-auction.facade'
import { AuctionsConstants } from 'libs/gb-dashboard/auctions/feature/src/lib/auctions.constants'
import { EventTicketsConstants } from 'libs/gb-dashboard/event-tickets/feature/src/lib/event-tickets-constants'
import { Observable } from 'rxjs'
import { map, take } from 'rxjs/operators'

/**
 * Guard which redirects to tickets list if non-saas with ticketing
 * disabled (list shows locked prompt), otherwise allows access.
 */
@Injectable({
  providedIn: 'root',
})
export class EventTicketsGuard implements CanActivate {
  constructor(
    private selectedAuctionFacade: SelectedAuctionFacade,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.selectedAuctionFacade.auction$.pipe(
      take(1),
      map((auction) => {
        // TODO (GB-12080): This is a temporary workaround to extract the urlName from the route parameters.
        // This handles cases where a user accesses the route directly via a link with no auction state,
        // as initialisation currently happens too late in the component lifecycle.
        const urlName = auction?.url_name || route.pathFromRoot.find((s) => s.params['urlName'])?.params['urlName']

        // if non-saas and ticketing disabled, redirect to event details to show locked prompt
        // OR if there is no auction in state (user navigates directly to route with empty state)
        // then navigate to the event details and the user can navigate as needed from there
        if (!auction || (!auction?.is_saas && !auction?.enable_ticketing)) {
          const urlFragments = [
            '/',
            AuctionsConstants.AUCTION,
            urlName,
            EventTicketsConstants.EVENT_TICKETS,
            EventTicketsConstants.EVENT_DETAILS,
          ]

          return this.router.createUrlTree(urlFragments)
        }

        return true
      }),
    )
  }
}
